module.exports = __webpack_public_path__ + "img/benefit-icon_calendar.ed5ad891.svg";